export default __webpack_public_path__ + "static/media/about.ad608531.png";